package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class StreakInfo(
    val currentStreak: Int = 0,
    val longestStreak: Int = 0,
    // ISO-8601 (yyyy-MM-dd), UTC, of the last daily puzzle completed.
    val lastCompletedDate: String? = null,
)
